module.exports = __webpack_public_path__ + "floral-ring.png?0899f323c61ca2fbd740256288f9b3ec";